import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  fr: {
    translation: frTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    // Détection fiable et persistante : le choix de l'utilisateur est
    // mémorisé dans localStorage et prioritaire sur la préférence système.
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'spotfli_lang',
      caches: ['localStorage']
    },
    // Initialisation synchrone (ressources déjà importées) : pas de flash
    // de langue au chargement.
    initImmediate: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
